export default __webpack_public_path__ + "static/media/19_1_2.0d7abc20.png";